module.exports = __webpack_public_path__ + "files/f5244a8e4f3332e7aa277928a7e4a1f3.png";